import type { StoreSettingsModal, StoreSettingsModalState } from './types';
import { create } from 'zustand';
import { SettingsTab } from './types';

function getInitialState(): StoreSettingsModalState {
  return {
    visible: false,
    activeTab: SettingsTab.SiteSetting,
    type: 'global',
    source: null,
  };
}

export const useSettingsModalStore = create<StoreSettingsModal>((set) => ({
  ...getInitialState(),
  setVisible: visible => set({ visible }),
  setActiveTab: tab => set({ activeTab: tab }),
  reset: () => set(getInitialState()),
}));
